import React, { Component } from "react";
import PropTypes from "prop-types";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import FormHelperText from "@material-ui/core/FormHelperText";

import "./Form.css";
import validate from "../../utils/validate";
import green from "@material-ui/core/colors/green";

const styles = theme => ({
  customChecked: {
    color: "#0A5DB8 !important"
  },
  customRoot: {
    display: "flex",
    height: "36px"
  },
  customLabel: {
    fontSize: "14px"
  }
});

class RadioField extends Component {
  state = {
    error: false,
    errorMessage: "",
    helpText: ""
  };

  componentDidMount() {
    this.validateFn(this.props.value, this.props.required, this.props.regEx);
  }

  componentWillReceiveProps(nextProps) {
    this.validateFn(nextProps.value, nextProps.required, nextProps.regEx);
  }

  handleChange = event => {
    const value = event.target.value;
    this.validateFn(value, this.props.required, this.props.regEx);
  };

  validateFn(value, required, regEx) {
    let errorObj = validate(value, required, regEx);
    this.setState(() => errorObj);

    if (this.props.onChanged) {
      this.props.onChanged(value, errorObj.error);
    }
  }

  displayHelpText = (event) => {
    let helpText = "";

    let selectedOption = this.props.dataSource.filter(
      i => i.value === event.target.value
    );
    if (selectedOption.length > 0) {
      helpText = selectedOption[0].helpText ? selectedOption[0].helpText : "";
    }

    this.setState(() => ({ helpText: helpText }));
  };

  render() {
    const {
      label,
      name,
      value,
      dataSource,
      editable,
      required,
      showError,
      classes
    } = this.props;
    return (
      <div>
        <FormLabel className="radio-group-label">
          <strong>{label}</strong>
          {this.state.error && showError ? (
            <span className="error-text">({this.state.errorMessage})</span>
          ) : (
            ""
          )}
        </FormLabel>
        <RadioGroup
          name={name}
          onChange={this.handleChange}
          value={value !== null ? value.toString() : ""}
          className="radio-group-btns"
        >
          {dataSource.map((item, i) => (
            <FormControlLabel
              key={item.value}
              classes={{ root: classes.customRoot, label: classes.customLabel }}
              disabled={!editable}
              value={item.value !== null ? item.value.toString() : ""}
              control={<Radio classes={{ checked: classes.customChecked }} />}
              label={item.display}
              onChange={this.displayHelpText}
            />
          ))}
        </RadioGroup>
        {this.state.helpText != "" ?
        (<FormHelperText filled={true}>{this.state.helpText}</FormHelperText>) : ""
        }
      </div>
    );
  }
}

RadioField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  dataSource: PropTypes.array,
  editable: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  onChanged: PropTypes.func
};

export default withStyles(styles)(RadioField);



// WEBPACK FOOTER //
// ./src/components/form/RadioField.js